import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7ed2f03f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed2f03f')) {
      api.createRecord('7ed2f03f', component.options)
    } else {
      api.reload('7ed2f03f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7ed2f03f&", function () {
      api.rerender('7ed2f03f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xMo4i2KZhoUf/JS/offershelp.vue"
export default component.exports